exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-form-item[data-v-491bbbb1]{margin-bottom:0}", ""]);

// exports
